module.exports = __webpack_public_path__ + "static/media/ep2.edc05d1a.jpg";